        <!-- UserNew 新增用户 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="userNew">
      <div class="userNew_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>新增用户</h1>
      <div class="userNew_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="userNew_content">
      <el-form ref="form" class="clearfix" :model="form" label-width="80px">
        <div class="form_box">
          <el-form-item :required="true" label="登录账号">
            <el-input
              placeholder="长度为4~12之间"
              v-model="form.shortId"
            ></el-input>
          </el-form-item>
          <el-form-item :required="true" label="归属机构">
            <el-cascader
              :clearable="true"
              v-model="value"
              :checkStrictly="true"
              :options="institutions"
              placeholder="系统管理机构"
              filterable
              :props="{ expandTrigger: 'hover', checkStrictly: true }"
              @change="handleChange"
            ></el-cascader>
            <!-- <el-select v-model="form.deptId" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item :required="true" label="用户角色">
            <el-checkbox-group v-model="form.roles">
              <el-checkbox label="协议卡管理" name="type"></el-checkbox>
              <el-checkbox label="HJ212管理" name="type"></el-checkbox>
              <el-checkbox label="协议卡查询" name="type"></el-checkbox>
              <el-checkbox label="HJ212查询" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="启用状态">
            <el-switch v-model="form.status"></el-switch>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="form.gender">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="form.idNumber"></el-input>
          </el-form-item>
          <el-form-item label="出生年月">
            <el-input v-model="form.birthDate"></el-input>
          </el-form-item>
        </div>
        <div class="form_box">
          <el-form-item :required="true" label="用户名称">
            <el-input v-model="form.userName"></el-input>
          </el-form-item>
          <el-form-item :required="true" label="登录方式">
            <el-radio-group v-model="form.loginType">
              <el-radio label="单点" value="0"></el-radio>
              <el-radio label="多点" value="1"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="邮编">
            <el-input v-model="form.postalcode"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div class="btns">
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      //  "0": "协议卡管理",
      //       "1": "HJ212管理",
      //       "2": "协议卡查询",
      //       "3": "HJ212查询"

      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 上级机构树list
      institutions: [],
      // 当前选择机构
      value: [],
      form: {
        deptId: "", //归属ID
        shortId: "", //登录账号
        userName: "", //用户名称
        loginType: "", //登录方式
        status: true, //启用状态
        roles: [], //用户角色
        regDate: "", //注册日期
        idNumber: "", //身份证号
        birthDate: "", //出生年月
        gender: "", //性别
        phone: "", //联系电话
        mobile: "", //手机
        email: "", //电子邮箱
        address: "", //地址
        postalcode: "", //邮编
        remark: "", //备注
      },
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    let n = date.getFullYear();
    let y = date.getMonth() + 1;
    let r = date.getDate();

    y = y > 9 ? y : "0" + y;
    r = r > 9 ? r : "0" + r;
    this.form.regDate = n + "-" + y + "-" + r;

    // // 获取机构树
    // let options = JSON.parse(localStorage.getItem("structure"));
    this.institutions = JSON.parse(localStorage.getItem("structure"));
    // // 调用获取上级机构
    // this.institutionsList(options);

    // this.fn();
  },
  methods: {
    fn() {
      this.logoHis = true;
      // 获取loginToken,deptId
      let loginToken = localStorage.getItem("loginToken");
      let deptId = localStorage.getItem("deptId");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "Keeper", //交易码
          loginToken,
        },
      })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 添加
    UserAdd(list) {
      this.$axios({
        method: "post",
        url: this.api,
        data: list,
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data._MESSAGE == "新增成功") {
              this.$message({
                type: "success",
                message: res.data._MESSAGE,
              });
              this.value = [];
              this.form = {
                deptId: "", //归属ID
                shortId: "", //登录账号
                userName: "", //用户名称
                loginType: "", //登录方式
                status: true, //启用状态
                roles: [], //用户角色
                regDate: "", //注册日期
                idNumber: "", //身份证号
                birthDate: "", //出生年月
                gender: "", //性别
                phone: "", //联系电话
                mobile: "", //手机
                email: "", //电子邮箱
                address: "", //地址
                postalcode: "", //邮编
                remark: "", //备注
              };
            }
            if (res.data._ERROR == "该员工号已存在,并处于正常状态") {
              this.$message({
                type: "warning",
                message: res.data._ERROR,
              });
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取上级机构
    institutionsList(options) {
      let data = options;
      let _this = this;
      for (let i = 0; i < data.length; i++) {
        (function (i) {
          if (data[i].children) {
            for (let j = 0; j < data[i].children.length; j++) {
              (function (i, j) {
                if (data[i].children[j].children) {
                  for (
                    let k = 0;
                    k < data[i].children[j].children.length;
                    k++
                  ) {
                    (function (i, j, k) {
                      if (data[i].children[j].children[k].children) {
                        data[i].children[j].children[k].children = undefined;
                      }
                    })(i, j, k);
                  }
                }
              })(i, j);
            }
          }
        })(i);
      }
      let arr = [
        {
          children: [],
          label: "顶级",
          level: 0,
          parentId: "000000000",
          value: "000000000",
        },
      ];
      arr[0].children = data;
      // 设置上级机构树
      this.institutions = arr;
    },
    // 提交
    onSubmit() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");

      if (
        this.form.shortId !== "" &&
        this.form.deptId !== "" &&
        this.form.userName !== "" &&
        this.form.loginType !== "" &&
        this.form.roles.length !== 0
      ) {
        if (this.form.shortId.length >= 4 && this.form.shortId.length <= 12) {
          let list = {
            txcode: "UserAdd", //交易码
            deptId: "", //归属机构ID，从机构树中选取。
            shortId: "", //登录账号，长度为4~12之间
            userName: "", //用户名称
            loginType: 0, //登录方式，0单点，1多点。
            status: 1, //启用状态，0停用，1启用。
            roles: "1,2", //用户角色，0系统管理员，1编辑员，2查询用户，3软件配置员。
            regDate: "", //注册日期，默认填当前日期，格式：yyyy-MM-dd
            idNumber: "", //身份证号
            birthDate: "", //出生日期
            gender: "M", //性别，M男，F女。
            phone: "", //联系电话
            mobile: "", //手机
            email: "", //电子邮箱
            address: "", //地址
            postalcode: "", //邮编
            remark: "", //备注
            loginToken,
          };
          list.shortId = this.form.shortId;
          list.deptId = this.form.deptId;
          list.userName = this.form.userName;
          list.regDate = this.form.regDate;
          if (this.form.loginType == "多点") {
            list.loginType = "1";
          } else {
            list.loginType = "0";
          }

          var roles = "";
          for (let i = 0; i < this.form.roles.length; i++) {
            if (this.form.roles[i] == "协议卡管理") {
              roles += "0,";
            }
            if (this.form.roles[i] == "HJ212管理") {
              roles += "1,";
            }
            if (this.form.roles[i] == "协议卡查询") {
              roles += "2,";
            }
            if (this.form.roles[i] == "HJ212查询") {
              roles += "3,";
            }
          }
          roles.slice(0, roles.length - 1);
          list.roles = roles;

          if (this.form.gender == "女") {
            list.gender = "F";
          } else {
            list.gender = "M";
          }

          this.UserAdd(list);

          // console.log(list);
        } else {
          this.$message({
            message: "登录账号不规范!",
            type: "warning",
          });
          return;
        }
      } else {
        this.$message({
          message: "必填参数不能为空!",
          type: "warning",
        });
        return;
      }
    },
    // 现在所属机构
    handleChange(value) {
      // this.form.deptId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.form.deptId = val[val.length - 1];
      } else {
        this.form.deptId = "";
      }
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>


<style lang="less" scoped>
// 表头
.userNew {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .userNew_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .userNew_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 内容
.userNew_content {
  width: calc(100% - 40px);
  height: calc(100% - 80px);
  position: fixed;
  top: 65px;
  left: 20px;
  padding-top: 30px;
  box-sizing: border-box;
  /deep/ .el-form {
    width: 100%;
    padding: 0 20%;
    box-sizing: border-box;
    display: flex;
    .form_box {
      width: 50%;
      padding-right: 10%;
      box-sizing: border-box;
    }
  }
  .btns {
    text-align: center;
    width: 100%;
    margin: 50px 0;
    .el-button {
      padding: 15px 100px;
    }
  }
}
</style>